import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { hasValidAuthSession } from "../utils/firebaseAuth";
import { getSession } from "../utils/session";
import "./ErrorStyles.scss";

const NotFound: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Check for valid session - if no valid token, redirect to login
  // This handles the PWA case where app opens with expired session
  useEffect(() => {
    const hasAuthSession = hasValidAuthSession();
    const userId = getSession("userId");

    // If no valid session exists, redirect to login instead of showing 404
    if (!hasAuthSession || !userId) {
      navigate("/login", { replace: true });
      return;
    }
  }, [navigate]);

  useEffect(() => {
    // Log 404 error to Sentry
    Sentry.captureMessage(`404 - Page not found: ${location.pathname}`, {
      level: "warning",
      tags: {
        type: "404",
        path: location.pathname,
      },
      extra: {
        fullUrl: window.location.href,
        referrer: document.referrer,
      },
    });
  }, [location.pathname]);

  const handleGoHome = () => {
    navigate("/dashboard");
  };

  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-icon">🔍</div>
        <h1 className="error-title">Page Not Found</h1>
        <p className="error-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button className="refresh-button" onClick={handleGoHome}>
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default NotFound;
